function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "b",
  width: "108.6%",
  height: "106%",
  x: "-4.3%",
  y: "-3%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "shadowBlurInner1",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "d",
  width: "105.2%",
  height: "105.2%",
  x: "-2.6%",
  y: "-2.6%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "shadowBlurInner1",
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "f",
  width: "102.9%",
  height: "102.9%",
  x: "-1.4%",
  y: "-1.5%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "shadowBlurInner1",
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M171.992 52.12c3.168 0 6.6-.144 10.296-.432 3.696-.288 7.032-.72 10.008-1.296 1.488-1.488 2.232-3.192 2.232-5.112 0-1.344-.372-2.58-1.116-3.708-.744-1.128-1.788-2.004-3.132-2.628-2.64.912-5.148 1.62-7.524 2.124-2.376.504-5.028.9-7.956 1.188l.72-3.456 1.296-6.48 9.288-.648c.816-.048 1.656-.096 2.52-.144a54.16 54.16 0 002.664-.216c.72-.528 1.284-1.236 1.692-2.124a6.73 6.73 0 00.612-2.844 6.352 6.352 0 00-.756-3.06c-.504-.936-1.236-1.692-2.196-2.268-3.312.768-7.368 1.344-12.168 1.728.72-3.6 1.488-6.864 2.304-9.792 4.128-.384 9.288-.624 15.48-.72.624-.624 1.128-1.416 1.512-2.376.384-.96.576-1.92.576-2.88 0-1.104-.228-2.124-.684-3.06a5.037 5.037 0 00-2.052-2.196c-3.552.528-7.764.888-12.636 1.08-4.872.192-10.596.336-17.172.432-1.488 1.488-2.232 3.192-2.232 5.112 0 1.104.276 2.124.828 3.06.552.936 1.284 1.644 2.196 2.124l3.024-.216c-.24 1.68-.744 4.392-1.512 8.136l-.792 3.96c-.768 3.84-1.56 7.536-2.376 11.088-1.104 4.848-1.656 7.632-1.656 8.352 0 .816.54 1.8 1.62 2.952a18.23 18.23 0 003.708 3.024c1.392.864 2.52 1.296 3.384 1.296z"
}), /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M73.128 270.82l11.745 11.745-11.358 11.358v13.364H86.88l11.357-11.357 11.568 11.568 1.782-1.782-36.676-36.678-1.782 1.782zm2.907 25.623h6.542l-6.542 6.542v-6.542zm1.782 8.324l6.542-6.542v6.542h-6.542zm18.64-10.62l-9.577 9.576v-8.019l5.567-5.566 4.01 4.01zm-5.793-5.79l-5.566 5.566H77.08l9.576-9.576 4.01 4.01z"
}), /*#__PURE__*/React.createElement("path", {
  id: "e",
  d: "M79.838 17.3a9.422 9.422 0 00-6.682-2.769 9.424 9.424 0 00-6.683 2.768l-.062.066-.002-.002-17.67 17.67a9.413 9.413 0 00-2.755-7.107l-.06-.058-.058-.06a9.45 9.45 0 00-13.683 13.028l-.008.008 5.391 5.391L27.061 56.74 15.315 44.994l-1.782 1.782 36.678 36.678 1.782-1.782-11.568-11.568L50.93 59.6l5.747 5.746.057-.057c3.706 2.862 9.048 2.596 12.447-.803a9.45 9.45 0 000-13.364l-.016-.015-.015-.016a9.414 9.414 0 00-6.977-2.762l17.602-17.602h-.002l.066-.064c3.69-3.69 3.69-9.674 0-13.364zm-6.682-.249c1.851 0 3.591.721 4.9 2.03 2.702 2.702 2.702 7.1 0 9.8a6.883 6.883 0 01-4.9 2.03 6.884 6.884 0 01-4.9-2.03c-2.702-2.702-2.702-7.099 0-9.8a6.88 6.88 0 014.9-2.03zm-5.789 45.622a6.88 6.88 0 01-4.897 2.028 6.86 6.86 0 01-4.203-1.418l-.207-.158a7.299 7.299 0 01-.463-.42L34.283 39.39l-.03-.032-.168-.19c-2.395-2.733-2.256-6.889.316-9.46a6.884 6.884 0 014.9-2.03c1.823 0 3.537.7 4.84 1.972 2.642 2.706 2.625 7.056-.055 9.738l-.832.832 1.782 1.782.891-.89-.002-.003c.128-.13.251-.263.37-.399l9.982 9.982a9.22 9.22 0 00-.399.37l-.002-.002-.89.891 1.781 1.782.83-.83c2.697-2.697 7.082-2.7 9.785-.014a6.936 6.936 0 01-.015 9.783zM48.242 39.094l3.92-3.92 9.801 9.8-3.92 3.92-9.8-9.8zm5.702-5.702l3.983-3.983 9.8 9.8-3.983 3.983-9.8-9.8zm-25.102 25.13l10.504-10.505 4.01 4.01L32.852 62.53l-4.01-4.01zm9.801 9.8l-4.01-4.009L45.137 53.81l4.01 4.01-10.504 10.503zM69.51 37.427l-9.8-9.8 4.005-4.005a9.422 9.422 0 002.76 7.042 9.422 9.422 0 006.682 2.768c.12 0 .24-.004.36-.008l-4.007 4.003z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M29.806 201.357c4.543-.397 8.653-1.468 12.332-3.211 3.678-1.743 6.506-3.834 8.485-6.271 1.98-2.438 2.866-4.829 2.661-7.172-.184-2.104-1.207-3.881-3.068-5.333-1.862-1.45-4.441-2.297-7.739-2.539 3.53-1.513 6.185-3.516 7.967-6.009 1.781-2.493 2.557-5.054 2.327-7.684-.23-2.63-1.546-4.996-3.946-7.1-2.4-2.102-5.526-3.683-9.377-4.744-3.851-1.06-7.952-1.4-12.304-1.02-2.869.252-6.342 1.037-10.418 2.358-.74 1.462-1.042 2.958-.908 4.488.184 2.104 1.138 3.924 2.862 5.46l2.48-.58c-.24 2.768-.811 7.805-1.714 15.112-1.215 9.79-1.783 15.14-1.704 16.05.088 1.003.83 2.18 2.224 3.527 1.395 1.347 3.037 2.493 4.926 3.436 1.89.942 3.528 1.353 4.914 1.232zm.679-26.946c.26-2.528.481-5.51.662-8.948.073-.825.182-2.328.328-4.51.566-.145 1.35-.262 2.355-.35 2.439-.213 4.454.104 6.046.953 1.592.848 2.449 1.966 2.57 3.353.176 2.008-.759 3.86-2.802 5.557-2.044 1.697-5.097 3.012-9.16 3.945zm-2.083 18.324c.373-2.346.997-5.677 1.872-9.994l.292-1.615c1.696-.438 3.29-.674 4.78-.708 1.739.041 3.06.407 3.963 1.1.904.691 1.404 1.587 1.5 2.687.172 1.96-.772 3.705-2.83 5.234-2.059 1.53-5.251 2.628-9.577 3.296zm41.905 4.79c2.725-.239 5.77-.674 9.137-1.306 3.365-.632 6.503-1.388 9.414-2.269 1.352-1.612 1.943-3.398 1.771-5.359a6.77 6.77 0 00-1.438-3.632c-.841-1.083-1.959-1.877-3.352-2.381a72.556 72.556 0 01-15.968 5.01c.808-5.081 1.393-9.131 1.756-12.15.544-4.24 1.36-9.226 2.45-14.959.057-.439.257-1.6.598-3.485.34-1.885.49-3.067.448-3.545-.07-.813-.74-1.718-2.008-2.715-1.268-.998-2.702-1.836-4.303-2.515-1.602-.679-2.857-.979-3.765-.9-.86.076-1.561 1.848-2.1 5.316-.54 3.468-1.052 7.946-1.536 13.433l-.298 3.206c-.45 4.762-.992 9.314-1.623 13.658-.655 4.634-.945 7.382-.87 8.243.072.813.682 1.735 1.833 2.767a18.436 18.436 0 003.882 2.66c1.438.74 2.59 1.098 3.455 1.07.53.002 1.369-.047 2.517-.147zm30.698-2.686c1.1-.096 2.283-.345 3.549-.744 1.28-4.642 2.4-8.908 3.361-12.798 1.614-.286 4.975-.965 10.085-2.039.464 5.308.824 8.312 1.078 9.013.254.7 1.024 1.38 2.31 2.038 1.286.658 2.728 1.17 4.326 1.537 1.598.366 2.923.503 3.975.41.43-.037.74-.088.927-.152.604-.246.79-1.708.555-4.386-.18-2.056-.56-4.612-1.14-7.67-.581-3.056-.929-4.965-1.043-5.726l-1.064-5.545a250.014 250.014 0 00-2.442-12.217c-.946-4.206-1.645-6.963-2.097-8.273-.258-.748-1.134-1.539-2.629-2.372-1.494-.833-3.143-1.508-4.947-2.024-1.804-.517-3.16-.736-4.068-.656-1.148.1-3.3 4.288-6.454 12.562-3.155 8.274-6.85 18.5-11.085 30.675l-1.152 3.353c.598 1.875 1.595 3.221 2.991 4.039 1.397.817 3.052 1.142 4.964.975zm9.743-24.125a322.935 322.935 0 014.84-16.541c.51 3.617 1.053 8.725 1.63 15.324-2.126.475-4.283.88-6.47 1.217zm38.267 20.214c3.586-.314 7.44-2.12 11.56-5.42a43.692 43.692 0 0010.218-11.664c2.692-4.475 3.886-8.458 3.58-11.949-.347-3.969-2.113-7.633-5.298-10.992-3.185-3.36-7.344-6.019-12.479-7.979-5.134-1.96-10.615-2.926-16.443-2.898-1.311.982-2.272 2.114-2.883 3.396a7.742 7.742 0 00-.728 4.075c.134 1.53.65 3.027 1.55 4.49l2.953-.113a33.954 33.954 0 01-.544 3.697c-.267 1.348-.43 2.242-.488 2.68-.55 3.084-.891 5.234-1.026 6.45-.35 3.163-.833 6.723-1.45 10.68-.63 3.813-.91 6.126-.839 6.94.08.908.88 2.078 2.403 3.511a23.949 23.949 0 005.203 3.7c1.945 1.035 3.516 1.5 4.711 1.396zm-.822-9.397c.36-3.597.96-8.853 1.8-15.769.671-5.551 1.166-9.81 1.485-12.777 2.919.322 5.565 1.247 7.94 2.774 2.374 1.527 3.642 3.223 3.805 5.088.277 3.156-1.018 6.666-3.885 10.53-2.866 3.865-6.58 7.25-11.145 10.154z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-5 1732.52 -56.784)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#4C3F96",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#b)",
  xlinkHref: "#a"
}))), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M6 223.606l212.189-18.564M6 133.606l212.189-18.564"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M144 220.042c13.807 0 25 11.193 25 25s-11.193 25-25 25-25-11.193-25-25 11.193-25 25-25zm-.028 17.266a7.706 7.706 0 100 15.413 7.706 7.706 0 000-15.413z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF7D00",
  d: "M144 234.042c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm-.028 5.192a5.78 5.78 0 100 11.56 5.78 5.78 0 000-11.56z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M143.972 218.042c-14.896 0-26.972 12.076-26.972 26.972 0 14.897 12.076 26.973 26.972 26.973 14.897 0 26.973-12.076 26.973-26.973a26.972 26.972 0 00-26.973-26.972zm0 50.091c-12.768 0-23.119-10.35-23.119-23.119 0-12.768 10.351-23.12 23.12-23.12 12.768 0 23.119 10.352 23.119 23.12a23.12 23.12 0 01-23.12 23.12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M143.972 233.455c-6.384 0-11.56 5.175-11.56 11.56 0 6.383 5.176 11.559 11.56 11.559 6.385 0 11.56-5.176 11.56-11.56s-5.175-11.56-11.56-11.56zm0 19.266a7.706 7.706 0 110-15.413 7.706 7.706 0 010 15.413z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M143.972 239.234a5.78 5.78 0 100 11.56 5.78 5.78 0 000-11.56zm0 9.633a3.853 3.853 0 110-7.706 3.853 3.853 0 010 7.706z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M27 230.042c13.807 0 25 11.193 25 25s-11.193 25-25 25-25-11.193-25-25 11.193-25 25-25zm-.028 17.266a7.706 7.706 0 100 15.413 7.706 7.706 0 000-15.413z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF7D00",
  d: "M27 244.042c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm-.028 5.192a5.78 5.78 0 100 11.56 5.78 5.78 0 000-11.56z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M26.972 228.042C12.076 228.042 0 240.118 0 255.014c0 14.897 12.076 26.973 26.972 26.973 14.897 0 26.973-12.076 26.973-26.973a26.972 26.972 0 00-26.973-26.972zm0 50.091c-12.768 0-23.119-10.35-23.119-23.119 0-12.768 10.351-23.12 23.12-23.12 12.768 0 23.119 10.352 23.119 23.12a23.12 23.12 0 01-23.12 23.12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M26.972 243.455c-6.384 0-11.56 5.175-11.56 11.56 0 6.383 5.176 11.559 11.56 11.559 6.385 0 11.56-5.176 11.56-11.56s-5.175-11.56-11.56-11.56zm0 19.266a7.706 7.706 0 110-15.413 7.706 7.706 0 010 15.413z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M26.972 249.234a5.78 5.78 0 100 11.56 5.78 5.78 0 000-11.56zm0 9.633a3.853 3.853 0 110-7.706 3.853 3.853 0 010 7.706z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M85 225.042c13.807 0 25 11.193 25 25s-11.193 25-25 25-25-11.193-25-25 11.193-25 25-25zm-.028 17.266a7.706 7.706 0 100 15.413 7.706 7.706 0 000-15.413z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF7D00",
  d: "M85 239.042c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm-.028 5.192a5.78 5.78 0 100 11.56 5.78 5.78 0 000-11.56z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M84.972 223.042C70.076 223.042 58 235.118 58 250.014c0 14.897 12.076 26.973 26.972 26.973 14.897 0 26.973-12.076 26.973-26.973a26.972 26.972 0 00-26.973-26.972zm0 50.091c-12.768 0-23.119-10.35-23.119-23.119 0-12.768 10.351-23.12 23.12-23.12 12.768 0 23.119 10.352 23.119 23.12a23.12 23.12 0 01-23.12 23.12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M84.972 238.455c-6.384 0-11.56 5.175-11.56 11.56 0 6.383 5.176 11.559 11.56 11.559 6.385 0 11.56-5.176 11.56-11.56s-5.175-11.56-11.56-11.56zm0 19.266a7.706 7.706 0 110-15.413 7.706 7.706 0 010 15.413z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M84.972 244.234a5.78 5.78 0 100 11.56 5.78 5.78 0 000-11.56zm0 9.633a3.853 3.853 0 110-7.706 3.853 3.853 0 010 7.706z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M202 215.042c13.807 0 25 11.193 25 25s-11.193 25-25 25-25-11.193-25-25 11.193-25 25-25zm-.028 17.266a7.706 7.706 0 100 15.413 7.706 7.706 0 000-15.413z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF7D00",
  d: "M202 229.042c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm-.028 5.192a5.78 5.78 0 100 11.56 5.78 5.78 0 000-11.56z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M201.972 213.042c-14.896 0-26.972 12.076-26.972 26.972 0 14.897 12.076 26.973 26.972 26.973 14.897 0 26.973-12.076 26.973-26.973a26.972 26.972 0 00-26.973-26.972zm0 50.091c-12.768 0-23.119-10.35-23.119-23.119 0-12.768 10.351-23.12 23.12-23.12 12.768 0 23.119 10.352 23.119 23.12a23.12 23.12 0 01-23.12 23.12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M201.972 228.455c-6.384 0-11.56 5.175-11.56 11.56 0 6.383 5.176 11.559 11.56 11.559 6.385 0 11.56-5.176 11.56-11.56s-5.175-11.56-11.56-11.56zm0 19.266a7.706 7.706 0 110-15.413 7.706 7.706 0 010 15.413z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M201.972 234.234a5.78 5.78 0 100 11.56 5.78 5.78 0 000-11.56zm0 9.633a3.853 3.853 0 110-7.706 3.853 3.853 0 010 7.706z"
}))), /*#__PURE__*/React.createElement("text", {
  fill: "#000",
  fontFamily: "Roboto-Bold, Roboto",
  fontSize: 18,
  fontWeight: "bold",
  letterSpacing: 3,
  transform: "rotate(-5 1030.628 59.52)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 13.299,
  y: 26
}, "I Match Your Trick")), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-50 116.495 257.008)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#4C3F96",
  xlinkHref: "#c"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#d)",
  xlinkHref: "#c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#4C3F96",
  d: "M97.842 19.245a1.57 1.57 0 01.363-1.15 1.575 1.575 0 11-.363 1.15zM118.332 47.444a1.576 1.576 0 11.274 3.14 1.576 1.576 0 01-.274-3.14zM87.193 51.75a1.574 1.574 0 11-3.139.275 1.574 1.574 0 011.433-1.707 1.576 1.576 0 011.706 1.432z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-50 81.058 -6.607)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#4C3F96",
  xlinkHref: "#e"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#f)",
  xlinkHref: "#e"
}))));

var SvgLogoFull = function SvgLogoFull(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 229 326",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoFull, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-full.5396d99b.svg";
export { ForwardRef as ReactComponent };